import { backendClient } from '../lib/api/backendClient';

type ImportArtistPayload = {
  spotifyArtistId: string;
  name?: string;
  imageUrl?: string;
  uri?: string;
  genres?: string[];
  savedAt?: string;
};

type ImportAlbumPayload = {
  spotifyAlbumId: string;
  name?: string;
  primaryArtistNames?: string[];
  imageUrl?: string;
  releaseDate?: string;
  totalTracks?: number;
  uri?: string;
  savedAt?: string;
  addedAt?: string;
};

type ImportPlaylistPayload = {
  spotifyPlaylistId: string;
  name?: string;
  uri?: string;
  ownerDisplayName?: string | null;
  description?: string | null;
  imageUrl?: string;
  savedAt?: string;
  lastPlayedAt?: string | null;
};

type ImportComposerPayload = {
  composerId: string;
  spotifyArtistId?: string;
  name?: string;
  imageUrl?: string;
  uri?: string;
  era?: string | null;
  birthYear?: string | number | null;
  deathYear?: string | number | null;
  savedAt?: string;
};

type ImportTrackPayload = {
  spotifyTrackId: string;
  addedAt?: string | number | Date | null;
  payload?: Record<string, unknown> | null;
};

type ImportLibraryPayload = {
  artists?: ImportArtistPayload[];
  albums?: ImportAlbumPayload[];
  playlists?: ImportPlaylistPayload[];
  composers?: ImportComposerPayload[];
  tracks?: ImportTrackPayload[];
};

export const libraryImportService = {
  async persistSpotifyLibrary(payload: ImportLibraryPayload): Promise<void> {
    await backendClient.post('/library/import/spotify', payload);
  },
};

export type {
  ImportArtistPayload,
  ImportAlbumPayload,
  ImportPlaylistPayload,
  ImportComposerPayload,
  ImportTrackPayload,
  ImportLibraryPayload,
};
